

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form3StatusInfoType } from '@/types/Information/Form3';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form3ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form3StatusInfoType;

}
